export const characters = {
  times: "\u{00d7}",
  ndash: "\u{2013}",
  nbsp: "\u00a0",
} as const;
